// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Revert = function Revert(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1.82 6.6a.27.27 0 00.26.27H6.7a.26.26 0 00.19-.45L5.23 4.77a4.16 4.16 0 012.77-1 4.31 4.31 0 11-3.62 6.65l-.8.52-.8.51a.35.35 0 000 .08A6.21 6.21 0 104 3.33l-.1.08-1.71-1.68a.26.26 0 00-.35.27z"
    }))
  );
};

export default Revert;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Revert.js
// module id = 1046
// module chunks = 0